import Vue from 'vue'

// STATE
const state = {
	
}

// GETTERS
const getters = {
	app: function(state) { return state }
}

// ACTIONS
const actions = {

}

// MUTATIONS
const mutations = {
	
}

export default { state, getters, actions, mutations }


// WEBPACK FOOTER //
// ./src/store/modules/app.js